export const normalizeSizes = (sizes: string[]) => {
    return sizes.filter((size) => !size.includes('Объект не найден'));
};
